module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_01-06d106ad3723632b92b53e774bf2f03c.jpg";